enum ListenerEvent {
  AddFavorite = 'add_favorite',
  CloseModal = 'close_modal',
  Error = 'error',
  FavoriteAdded = 'favorite_added',
  FavoriteRemoved = 'favorite_removed',
  RefreshFinancing = 'refresh_financing',
  RemoveFavorite = 'remove_favorite',
  SaveSearch = 'save_search',
  TradeInToggled = 'trade_in_toggled',
  UpdateGeolocation = 'update_geolocation'
}

export default ListenerEvent;
